<i18n src="./../../i18n/departments_page.json"></i18n>

<template>
    <div id="departments-page">
        <vue-headful
                :title="$t('pageTitle')"
                :description="$t('pageDescription')"
                :url="pageUrl"/>
        <navigation-bar />

        <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-cart-header-image.jpg">
            <div class="container">
                <p class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;" v-text="$t('header')" />
            </div>
        </div>

        <div class="container-fluid mt-subpage-section m-0 p-0">
            <div class="container-fluid m-0 p-0">
                <div class="lazy container-fluid">

                    <div class="container">
                        <div class="content-container p-3 pt-5">
                            <div class="container pt-3 pb-3">
                                <h1 v-text="$t('departments')" />
                            </div>
                            <div class="container">
                                <div class="row">
                                    <div class="col-lg-4 col-12 border-left pb-2" v-for="item in content" :key="item.title">
                                        <div class="row pt-3 pb-2">
                                            <div class="col-3 p-0 pt-1 text-right"><img class="lazy mt-location" data-src="/assets/mt-location.png" alt="location"></div>
                                            <div class="col-9">
                                                <p><strong>{{ $t('department') }} {{item.city}}</strong></p>
                                                <p v-if="item.addressNextLine" v-text="item.addressNextLine"/>
                                                <p v-text="item.address"/>
                                                <p v-if="item.postal" v-text="item.postal + ' ' + item.city"/>
                                                <p v-else v-text="item.city"/>
                                                <router-link v-if="item.url" :to="{name: 'departmentPage', params: {department: cleanPath(item.url)}}" v-text="$t('departmentSite')"></router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <main-footer/>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {Const} from "@/main";
    import NavigationBar from "@/components/commons/NavigationBar";
    import MainFooter from "@/components/commons/MainFooter";
    import LazyLoad from "vanilla-lazyload";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "DepartmentsPage",
        components: {MainFooter, NavigationBar},
        data () {
            return {
                locale: this.$i18n.locale,
                content: {},
                exist: false,
                loaded: false,
                pageUrl: Const.HOST + this.$route.path
            }
        },
        mounted () {
            axios.get(`${Const.API_HOST}/${this.locale}/content/departments`)
                .then(function (response) {
                    return response.data;
                }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(body => {
                this.content = body
                this.loaded = true

                this.$nextTick(() => {
                    lazyLoadInstance.update()
                })
            });
        },
        methods: {
            cleanPath(path) {
                return path.startsWith('/') ? path.substring(1) : path;
            }
        }
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }

    p {
        height: 0.7rem;
    }
</style>